import { render, staticRenderFns } from "./IIIFViewer.vue?vue&type=template&id=099b01b3&"
import script from "./IIIFViewer.vue?vue&type=script&lang=ts&"
export * from "./IIIFViewer.vue?vue&type=script&lang=ts&"
import style0 from "./IIIFViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports